'use client'

import { useState } from 'react'

import type { TLanguageSelectDesktopProps } from './LanguageSelectDesktop'
import { LanguageSelectDesktopTrigger } from './LanguageSelectDesktopTrigger'
import { LazyLanguageSelectDesktop } from './LazyLanguageSelectDesktop'

export const LazyLanguageSelectDesktopWithFallback = (
	props: TLanguageSelectDesktopProps,
) => {
	const [isOpen, setIsOpen] = useState(false)
	const [hasLoaded, setHasLoaded] = useState(false)

	return (
		<div>
			{!hasLoaded ? (
				<LanguageSelectDesktopTrigger
					{...props}
					onPointerDown={() => setIsOpen(true)}
				/>
			) : null}
			<LazyLanguageSelectDesktop
				{...props}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				setHasLoaded={setHasLoaded}
			/>
		</div>
	)
}
